import { handler as parcelsQueryHandler } from "./parcels.query";
import { handler as orderSummaryQueryHandler } from "./orderSummary.query";
import { handler as moveItemFromCartToWishlistHandler } from "./moveItemFromCartToWishlist.mutation";
import { handler as addToCartMutationHandler } from "./addToCart.mutation";
import { handler as addItemsToCartMutationHandler } from "./addItemsToCart.mutation";
import { handler as removeItemFromCartMutationHandler } from "./removeItemFromCart.mutation";
import { handler as updateCartItemQuantityMutationHandler } from "./updateCartItemQuantity.mutation";
import { handler as updateCartCouponMutationHandler } from "./updateCartCoupon.mutation";
import { handler as redeemGiftCardMutationHandler } from "./redeemGiftCard.mutation";
import { handler as cartUpsellRecommendationQueryHandler } from "./cartUpsellRecommendation.query";
import { handler as removeCouponFromCartMutationHandler } from "./removeCouponFromCart.mutation";
import { handler as removeGiftCardFromCartMutationHandler } from "./removeGiftCardFromCart.mutation";
import { handler as updateCartShippingOptionMutationHandler } from "./updateCartShippingOption.mutation";
import { handler as userCouponQueryHandler } from "./userCoupon.query";

// NOTE: The components in which these queries and mutations are
// used are noted next to the mock handlers below
export const cartHandlers = [
  parcelsQueryHandler, // CartContainer.tsx
  orderSummaryQueryHandler, // OrderSummaryContainer.tsx
  moveItemFromCartToWishlistHandler, // WishlistButton.tsx
  addToCartMutationHandler, //AddToCartButton.tsx
  addItemsToCartMutationHandler, //AddItemsToCartButton.tsx
  removeItemFromCartMutationHandler, // LineItem.tsx
  updateCartItemQuantityMutationHandler, // UpdateItemQuantity.tsx
  updateCartCouponMutationHandler, // CouponInput.tsx
  redeemGiftCardMutationHandler, //GiftCardInput.tsx
  cartUpsellRecommendationQueryHandler, // CartUpsellRecommendation.tsx
  removeCouponFromCartMutationHandler, // OrderSummaryInfo.tsx
  removeGiftCardFromCartMutationHandler, // OrderSummaryInfo.tsx
  userCouponQueryHandler, // CouponGiftCard.tsx
  updateCartShippingOptionMutationHandler, // DeliveryContainer.tsx
];
